import { atom } from 'nanostores';
import { PromptColumn } from '../api';

/**
 * The set of projects in the current scope (org/workspace)
 */
export const $promptColumns = atom<PromptColumn[]>([]);
